<div
  class="sync-status"
  [class]="'sync-status-' + status().state"
  [class.collapsed]="collapsed()"
  [title]="status().title + ' · ' + status().message"
  role="button"
  tabindex="0"
  (click)="onOpen()"
  (keydown.enter)="onOpen()"
  (keydown.space)="onOpen()">
  <span class="sync-icon" aria-hidden="true">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M3 7C3 4.791 4.791 3 7 3H9C11.209 3 13 4.791 13 7V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M13 9C13 11.209 11.209 13 9 13H7C4.791 13 3 11.209 3 9V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M11 5L13 3L13 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 11L3 13L3 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
  @if (!collapsed()) {
    <div class="sync-text">
      <span class="sync-title">{{ status().title }}</span>
      <span class="sync-subtitle">{{ status().message }}</span>
    </div>
  }
  <span class="sync-dot" aria-hidden="true"></span>
</div>
